var _defs, _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavegando(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d5164365dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 13 L 12 13 L 12 27.78125 L 1 27.78125 Z M 1 13 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 12.699219 11.453125 C 13.238281 11.242188 13.824219 11.125 14.4375 11.125 C 16.109375 11.125 17.578125 11.988281 18.421875 13.285156 C 19.671875 11.59375 20.511719 9.269531 20.050781 6.964844 C 19.503906 4.238281 17.15625 1.660156 14.175781 1.261719 C 11.535156 0.910156 8.367188 2.269531 7.941406 4.191406 C 7.710938 5.21875 9.871094 6.691406 11.058594 8.511719 C 11.804688 9.660156 12.328125 10.632812 12.699219 11.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5164365dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 7.511719 27.167969 C 8.527344 26.847656 8.734375 24.261719 9.738281 22.335938 C 10.375 21.121094 10.960938 20.1875 11.496094 19.460938 C 10.40625 18.601562 9.707031 17.28125 9.707031 15.800781 C 9.707031 15.027344 9.898438 14.292969 10.238281 13.652344 C 8.132812 13.425781 5.675781 13.867188 3.886719 15.414062 C 1.769531 17.246094 0.6875 20.542969 1.828125 23.292969 C 2.839844 25.730469 5.613281 27.761719 7.511719 27.167969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 14.652344 20.472656 C 15.507812 22.386719 17.121094 24.265625 19.371094 25.023438 C 22.035156 25.921875 25.46875 25.199219 27.304688 22.847656 C 28.933594 20.761719 29.328125 17.371094 27.859375 16.046875 C 27.070312 15.335938 24.703125 16.449219 22.511719 16.554688 C 21.132812 16.617188 20.019531 16.582031 19.117188 16.488281 C 18.789062 18.671875 16.925781 20.371094 14.652344 20.472656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 14.4375 12.214844 C 12.4375 12.214844 10.808594 13.824219 10.808594 15.800781 C 10.808594 17.777344 12.4375 19.386719 14.4375 19.386719 C 16.4375 19.386719 18.066406 17.777344 18.066406 15.800781 C 18.066406 13.824219 16.4375 12.214844 14.4375 12.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavegando);
export default __webpack_public_path__ + "static/media/Navegando.1fc293d2a8bf413b5c00477d92077f93.svg";
export { ForwardRef as ReactComponent };